import { CONTEXT_PROPS } from '../../types/ContextProps';
import { get, getRawValue } from '../../utils/get';
import { WIX_COM_DOMAINS, WIX_DOMAINLESS_IDS } from '../../consts';
import { getPageUrl } from './adapter-utils/get-page-url';
var isWixUrl = function (url) {
    return WIX_DOMAINLESS_IDS.some(function (domain) { return url.includes(domain); });
};
var isWixComSite = function (url) {
    return WIX_COM_DOMAINS.some(function (domain) { return url.includes(domain); });
};
export var isSubdirectory = function (url) {
    try {
        var urlObj = new URL(url);
        return urlObj.pathname !== '/';
    }
    catch (_a) {
        return true;
    }
};
var isInvalidName = function (siteName) {
    var lowerCaseSiteName = siteName.toLowerCase();
    var forbiddenTerms = ['copy of', 'site', 'website', 'copy', 'video'];
    return forbiddenTerms.some(function (word) { return lowerCaseSiteName.includes(word); });
};
export var isEligibleForHomepageSD = function (item) {
    var name = get(item, "context.".concat(CONTEXT_PROPS.SITE_NAME));
    var url = getPageUrl(item);
    return (getRawValue(item, "context.".concat(CONTEXT_PROPS.IS_HOME_PAGE)) &&
        !isInvalidName(name) &&
        !isWixUrl(url) &&
        !isSubdirectory(url) &&
        !isWixComSite(url));
};
